import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Field } from 'formik';
import { I18N } from 'commons';
import { DatePicker } from '@eb/antd'
import moment from 'moment';
import { Moment } from 'moment'
import ErrorMessage from '../ErrorMessage';


const DateSection = ({
  name, type, title, className, isOptional, values, touched, errors, isDisable, setFieldValue, ...props
}) => {
  const { RangePicker } = DatePicker;
  const hasTouched = _.has(touched, name) && !!touched[name];
  const hasError = _.has(errors, name) && !!errors[name];
  const a11yAttributes = (hasTouched && hasError) ? {
    'aria-invalid': true,
    'aria-labelledby': `${name}Label`
  } : {
    'aria-labelledby': `${name}Label`
  };
  return (
    <div className={className}>
      <label className="col-form-label" htmlFor={name}>
        <span id={`${name}Label`}><I18N>{title}</I18N>
          {
            !isOptional &&
            <span className="sr-only"><I18N>information.label.required</I18N></span>
          }
        </span>
        {
          !isOptional &&
            <span aria-hidden="true" className="required-star">*</span>
        }
      </label>
      <div>
        <Field
          //autoComplete="off"
          //disabled={isDisable}
          readOnly={true}
          name={name}
          //id={name}
          className="form-control"
          value={values[name]}
          required={!isOptional}
          {...props}
          {...a11yAttributes}
          render={() => (
                <>
                  <DatePicker
                    disabled={isDisable}
                    format="MMM DD, YYYY HH:mm"
                    size='large'
                    showTime={{ format: 'HH:mm' }}
                    value={values[name] ? moment(values[name]) : undefined}
                    onChange={value => {setFieldValue(name, value? value.format("YYYY-MM-DD HH:mm") : '')}}
                    showNow
                    />
                </>
            )}
        />
      </div>

      {hasTouched && hasError &&
        <div>
          <ErrorMessage id={`${name}Desc`} aria-hidden="true">{errors[name]}</ErrorMessage>
        </div>
      }
    </div>
  );
};

DateSection.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  values: PropTypes.shape().isRequired,
  touched: PropTypes.shape().isRequired,
  errors: PropTypes.shape().isRequired,
  type: PropTypes.string,
  isOptional: PropTypes.bool,
};

DateSection.defaultProps = {
  type: 'date',
  isOptional: false,
};

export default DateSection;